import React from "react";

const About = () => {
  console.log("hey");
  return <div>About</div>;
};

export default About;
